<div fxLayout="column" fxLayoutGap="15px">
  <div fxLayout="column" fxLayoutGap="15px">

    <div fxLayout="row" fxLayoutGap="15px" *ngIf="!overvoltage">
      <app-dict-partners
        fxFlex="50" label="Partner"
        [control]="partnerControl"
      ></app-dict-partners>

      <app-dict-ofwcas
        fxFlex="50" label="OFWCA"
        [control]="ofwcaControl"
      ></app-dict-ofwcas>
    </div>
    <div fxLayout="row" fxLayoutGap="15px"  *ngIf="overvoltage">

        <h3>Przepięcie OFWCA</h3>

    </div>
    <div fxLayout="row" fxLayoutGap="15px"  *ngIf="overvoltage">
      <app-dict-ofwcas
        fxFlex="100" label="OFWCA"
        [control]="ofwcaControl"
        [required]="overvoltage"
      ></app-dict-ofwcas>
    </div>

    <div fxLayout="row">
      <app-dict-insurance-companies
        fxFlex="100" label="TU" [required]="true"
        [control]="insuranceCompanyControl"
        (selectedInsuranceCompany)="insuranceCompanyChanged($event)"
        [hideChildren]="true"
      ></app-dict-insurance-companies>
    </div>

    <div fxLayout="row">
      <app-dict
        fxFlex="100"
        [control]="importerControl"
        [dictType]="'commission_importer_' + selectedInsuranceCompany?.key"
        matTooltip="Najpierw wybierz TU"
        matTooltipPosition="left"
        [matTooltipDisabled]="!!selectedInsuranceCompany"
        label="Importer"
      ></app-dict>
    </div>
    <div fxLayout="row" fxLayoutGap="15px" *ngIf="overvoltage">
      <app-dict-partners
        fxFlex="100" label="Partner rozliczeniowy"
        [control]="partnerControl"
        [required]="overvoltage"
      ></app-dict-partners>
    </div>

    <div fxLayout="row" *ngIf="!overvoltage">
      <app-dict
        fxFlex="100" label="Ryzyko ASF"
        dictType="internal_risk" [required]="false"
        [control]="internalRiskControl"
      ></app-dict>
    </div>

    <div fxLayout="row" fxLayoutGap="15px" *ngIf="!overvoltage">
      <mat-form-field fxFlex="50">
        <mat-label>Nazwa klienta</mat-label>
        <input matInput placeholder="Nazwa klienta" [formControl]="customerNameControl">
      </mat-form-field>

      <mat-form-field fxFlex="50">
        <mat-label>Numer polisy</mat-label>
        <input matInput placeholder="Numer polisy" [formControl]="policyNumberControl">
      </mat-form-field>
    </div>

    <div fxLayout="row" fxLayoutGap="15px" *ngIf="!overvoltage">
      <mat-form-field fxFlex="50">
        <mat-label>Stawka % Partner</mat-label>
        <input matInput placeholder="Stawka % Partner" [formControl]="ratePaidControl">
      </mat-form-field>

      <app-dict
        fxFlex="50"
        [control]="policyTypesControl"
        [multiple]="true"
        dictType="sold_policy_type"
        label="Typ polisy"
      ></app-dict>
    </div>

    <div fxLayout="row" fxLayoutGap="15px" *ngIf="overvoltage">
      <app-dict
        fxFlex="100"
        [control]="policyTypesControl"
        [multiple]="true"
        dictType="sold_policy_type"
        label="Typ polisy"
      ></app-dict>
    </div>

    <div fxLayout="row" fxLayoutGap="15px" *ngIf="overvoltage">
      <app-datepicker
        fxFlex="50"
        label="Data zawarcia polisy od"
        placeholder="2000-01-01 00:00"
        [control]="activePolicyFromControl"
      ></app-datepicker>

      <app-datepicker
        fxFlex="50"
        label="Data zawarcia polisy do"
        placeholder="2000-01-01 00:00"
        [control]="activePolicyToControl"
      ></app-datepicker>

    </div>

    <div fxLayout="row" fxLayoutGap="15px" *ngIf="!overvoltage">
      <app-datepicker
        fxFlex="50"
        label="Data od"
        placeholder="2000-01-01 00:00"
        [control]="activeFromControl"
      ></app-datepicker>

      <app-datepicker
        fxFlex="50"
        label="Data do"
        placeholder="2000-01-01 00:00"
        [control]="activeToControl"
      ></app-datepicker>
    </div>

    <div fxLayout="row" fxLayoutGap="15px" *ngIf="overvoltage">
      <app-datepicker
        fxFlex="50"
        label="Data aktywacji aneksu"
        placeholder="2000-01-01 00:00"
        [control]="activeFromControl"
      ></app-datepicker>

      <app-datepicker
        fxFlex="50"
        label="Data dezaktywacji aneksu"
        placeholder="2000-01-01 00:00"
        [control]="activeToControl"
      ></app-datepicker>
    </div>

    <div fxLayout="column">
        <mat-slide-toggle class="slide-padding" color="accent" [formControl]="archiveControl">Archiwum</mat-slide-toggle>
        <mat-slide-toggle class="slide-padding" color="accent" [formControl]="standard2025Control">Standard 2025</mat-slide-toggle>
        <mat-slide-toggle class="slide-padding" color="accent" [formControl]="standard2026Control">Standard 2026</mat-slide-toggle>
        <mat-slide-toggle class="slide-padding" color="accent" [formControl]="customCommissionControl">Prowizja niestandardowa</mat-slide-toggle>
    </div>
  </div>
  <div fxLayout="row" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="!annexForm.valid"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>

    <button (click)="closeDialog()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>

